import React from "react";
import BasicButton from "../../Shared/components/BasicButton";
import Hero from "../../Shared/components/Hero";

const BinaryHealthProblems = ({ onClick }) => {
  return (
      <div className="flex flex-1 flex-col justify-between">
          <Hero>Avez-vous des problèmes de santé ?</Hero>
          <div className="flex justify-center">

        <BasicButton onClick={() => onClick(true)} className="mr-6">oui</BasicButton>
        <BasicButton onClick={() => onClick(false)}>non</BasicButton>
      </div>
      <div/>
    </div>
  );
};

export default BinaryHealthProblems;
